<div class="mat-dialog-container">
        <!-- 明細編輯開始 -->
        <div #head>
                <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state"
                        (onOkClick)="doOk($event)" (onCancelClick)="doCancel($event)" (onEditAndSaveClick)="doEditAndSave(item)">
                </app-modal-header>
                <app-jkcheckbox label="admin" #adminCom id="admin" [(value)]="srv.isAdmin" [readonly]="true"
                        [visible]="srv.isAdmin">
                </app-jkcheckbox>

        </div>
        <div class="jk-content">
                <mat-tab-group>

                        <!-- Tab 1: 基本資料 -->
                        <mat-tab label="基本資料">
                                <div class="jk-grid-cols-2">
                                        <app-jkdatefield label="單據日期" #WB004Com id="WB004" [(value)]="item.WB004"
                                                [required]="true" placeholder="單據日期" [readonly]="isBrowse"
                                                (onValueChange)="srv.WB004Change(item,$event)">
                                        </app-jkdatefield>
                                        <app-jkedit label="反應者姓名" #WB005Com id="WB005" [(value)]="item.WB005"
                                                [required]="true" placeholder="反應者姓名" [readonly]="isBrowse">
                                        </app-jkedit>
                                        <app-jkedit label="EMAIL" #WB016Com id="WB016" [(value)]="item.WB016"
                                                [required]="true" placeholder="EMAIL" [readonly]="isBrowse">
                                        </app-jkedit>
                                        <app-jkedit label="程式代號" #WB008Com id="WB008" [(value)]="item.WB008"
                                                placeholder="程式代號" [readonly]="isBrowse"
                                                (valueChange)="toUpperCaseField('WB008', $event)">
                                        </app-jkedit>
                                        <app-jkedit label="程式名稱" #WB009Com id="WB009" [(value)]="item.WB009"
                                                [required]="true" placeholder="程式名稱" [readonly]="isBrowse">
                                        </app-jkedit>
                                        <app-jkedit label="部門" #WB006Com id="WB006" [(value)]="item.WB006"
                                                [readonly]="isBrowse"
                                                (valueChange)="toUpperCaseField('WB006', $event)">
                                        </app-jkedit>
                                        <app-jkcombobox label="狀態碼" #WB013Com id="WB013" [(value)]="item.WB013"
                                                [items]="srv.MtrWb013List" [readonly]="isBrowse">
                                        </app-jkcombobox>
                                        <app-jkdatefield label="期望完工日" #WB022Com id="WB022" [(value)]="item.WB022"
                                                placeholder="期望完工日" [readonly]="isBrowse">
                                        </app-jkdatefield>
                                        <app-jkcheckboxYN label="結案碼" #WB014Com id="WB014" [(valueYN)]="item.WB014"
                                                [readonly]="!srv.isAdmin">
                                        </app-jkcheckboxYN>
                                        <app-jkcheckboxYN label="有附件" #WB025Com id="WB025" [(valueYN)]="item.WB025"
                                                [readonly]="isBrowse">
                                        </app-jkcheckboxYN>
                                        @if(srv.isAdmin){
                                        <app-jkbtnedit label="反應者代號" #WB003Com id="WB003" [(value)]="item.WB003"
                                                [required]="true" [displayName]="itemAny.WB003C" maintable="SYSUser"
                                                item="W01" valueExpr="UserID" displayExpr="UserName" placeholder="反應者代號" [readonly]="isBrowse"
                                                (valueChange)="WB003Change(item,$event)">
                                        </app-jkbtnedit>
                                        <app-jkbtnedit label="客戶代號" #WB024Com id="WB024" [(value)]="item.WB024"
                                                [required]="true" maintable="COPMA" item="W01" valueExpr="MA001" displayExpr="MA002"
                                                [displayName]="itemAny.WB024C" placeholder="客戶代號"
                                                [readonly]="!srv.isAdmin" (valueChange)="srv.WB024Change($event)">
                                        </app-jkbtnedit>
                                        }@else{
                                        <app-jktext label="反應者代號" #WB003Com id="WB003" [value]="item.WB003"
                                                [required]="true" placeholder="反應者代號">
                                        </app-jktext>
                                        <app-jktext label="客戶代號" #WB024Com id="WB024" [value]="item.WB024"
                                                [required]="true" placeholder="客戶代號">
                                        </app-jktext>
                                        }
                                        <app-jkcombobox label="處理順序" #WB012Com id="WB012" [(value)]="item.WB012"
                                                [items]="srv.MtrWb012List" [readonly]="isBrowse">
                                        </app-jkcombobox>
                                        <!-- 問題敘述說明 - Quill 富文字編輯器 (含 MinIO 圖片上傳) -->
                                        <app-jk-rich-editor [minHeight]="'250px'" [(value)]="item.WB010" [readonly]="isBrowse" label="問題敘述說明"
                                                [required]="true" [path]="getImagePath(item)" [host]="srv.host">
                                        </app-jk-rich-editor>
                                        <app-jk-rich-editor [minHeight]="'250px'" [(value)]="item.WB011" [readonly]="isBrowse" label="處理說明"
                                                [required]="false" [path]="getImagePath(item)" [host]="srv.host">
                                        </app-jk-rich-editor>
                                </div>
                        </mat-tab>

                        <!-- Tab 2: 管理資料 (日期時數) -->
                        <mat-tab label="管理資料">
                                <div class="jk-grid-cols-2">
                                        <app-jkcombobox label="類別" #WB007Com id="WB007" [(value)]="item.WB007"
                                                [items]="srv.MtrWb007List" [readonly]="isBrowse">
                                        </app-jkcombobox>
                                        @if(srv.isAdmin){
                                        <app-jkdatefield label="預計完工日" #WB015Com id="WB015" [(value)]="item.WB015"
                                                placeholder="預計完工日" [readonly]="isBrowse">
                                        </app-jkdatefield>
                                        }
                                        <app-jkdatefield label="預計開工日" #WB020Com id="WB020" [(value)]="item.WB020"
                                                placeholder="預計開工日" [readonly]="!srv.isAdmin">
                                        </app-jkdatefield>
                                        <app-jkdatefield label="交件日" #WB021Com id="WB021" [(value)]="item.WB021"
                                                placeholder="交件日" [readonly]="!srv.isAdmin">
                                        </app-jkdatefield>
                                        <app-jknumberedit label="實際工時" #WB017Com id="WB017" [(value)]="item.WB017"
                                                placeholder="實際工時" [readonly]="isBrowse">
                                        </app-jknumberedit>
                                        <app-jknumberedit label="報價工時" #WB018Com id="WB018" [(value)]="item.WB018"
                                                placeholder="報價工時" [readonly]="isBrowse">
                                        </app-jknumberedit>
                                        <app-jktext label="訂單單號" [value]="item.WB019">
                                        </app-jktext>
                                        <app-jkedit label="程式人員" #WB028Com id="WB028" [(value)]="item.WB028"
                                                placeholder="程式人員" [readonly]="isBrowse">
                                        </app-jkedit>
                                        <app-jkcheckboxYN label="已報價" #WB026Com id="WB026" [(valueYN)]="item.WB026"
                                                [readonly]="isBrowse">
                                        </app-jkcheckboxYN>
                                        <app-jkcheckboxYN label="已回簽" #WB027Com id="WB027" [(valueYN)]="item.WB027"
                                                [readonly]="isBrowse">
                                        </app-jkcheckboxYN>
                                        <app-jkcheckboxYN label="已交件" #WB029Com id="WB029" [(valueYN)]="item.WB029"
                                                [readonly]="isBrowse">
                                        </app-jkcheckboxYN>
                                        <app-jkedit label="附件網址" #WB037Com id="WB037" [(value)]="item.WB037"
                                                placeholder="附件網址" [readonly]="isBrowse">
                                        </app-jkedit>
                                        <app-jk-rich-editor [minHeight]="'250px'" [(value)]="item.WB036" [readonly]="isBrowse" label="傑克程式說明"
                                                [required]="false" [path]="getImagePath(item)" [host]="srv.host || ''">
                                        </app-jk-rich-editor>
                                        <app-jktext label="單號" [value]="item.WB002">
                                        </app-jktext>

                                        <app-jknumberedit label="附件數" #WB035Com id="WB035" [(value)]="item.WB035"
                                                placeholder="附件數" [readonly]="isBrowse">
                                        </app-jknumberedit>
                                </div>
                        </mat-tab>

                        <!-- Tab 3: 系統管理 (admin 才看得到) -->
                        @if(srv.isAdmin){
                        <mat-tab label="系統管理">
                                <div class="jk-grid-cols-2">
                                        <app-jktext label="單別" #WB001Com id="WB001" [value]="item.WB001"
                                                [required]="true" placeholder="單別">
                                        </app-jktext>
                                        <app-jktext label="單號" [value]="item.WB002">
                                        </app-jktext>
                                        <app-jktext label="序號" [value]="item.WB023">
                                        </app-jktext>
                                        <app-jkedit label="預留欄位" #WB030Com id="WB030" [(value)]="item.WB030"
                                                placeholder="預留欄位" [readonly]="isBrowse">
                                        </app-jkedit>
                                        <app-jkedit label="預留欄位" #WB031Com id="WB031" [(value)]="item.WB031"
                                                placeholder="預留欄位" [readonly]="isBrowse">
                                        </app-jkedit>
                                        <app-jkedit label="預留欄位" #WB032Com id="WB032" [(value)]="item.WB032"
                                                placeholder="預留欄位" [readonly]="isBrowse">
                                        </app-jkedit>
                                        <app-jkedit label="預留欄位" #WB033Com id="WB033" [(value)]="item.WB033"
                                                placeholder="預留欄位" [readonly]="isBrowse">
                                        </app-jkedit>
                                        <app-jkedit label="預留欄位" #WB034Com id="WB034" [(value)]="item.WB034"
                                                placeholder="預留欄位" [readonly]="isBrowse">
                                        </app-jkedit>
                                </div>
                        </mat-tab>
                        }

                </mat-tab-group>
        </div>
</div>
